import AmountInputWithError from 'javascripts/components/AmountInputWithError';
import React from 'react';
import store from 'javascripts/store.js';
import t from 'javascripts/utils/translation';
import {autorun} from 'mobx';
import {observer} from 'mobx-react';

@observer
class DonateFormAmountInput extends AmountInputWithError {
  componentDidMount = () => {
    autorun(() => {
      if(store.donateForm.amountInputShouldFocus) {
        this.amountInput.focus();
        this.amountInput.select();
        store.donateForm.amountInputShouldFocus = !store.donateForm.amountInputShouldFocus;
      }
    });
  };

  render () {
    const {
      focus,
      maxAmount,
      readOnly,
    } = this.props;

    const {
      amount,
      campaignId,
      isSubscription,
      currencyUnit,
    } = store.donateForm;

    return (
      <div>
        <div className='amount-wrapper'>
          <div className={`input-wrapper lh donate-amount ${campaignId}`}>
            <label htmlFor='amount'>
              Donation Amount
            </label>
            <div className='input-field-container'>
              <span className='preinput'>{currencyUnit}</span>
              <input
                autoFocus={focus}
                data-amount='true'
                data-parsley-currency={`${this.minimumAmount(isSubscription)},${maxAmount}`}
                data-parsley-error-message={this.errorMsg(isSubscription, amount)}
                data-parsley-errors-container={`.donate-amount.${campaignId} .error`}
                name='amount'
                onChange={event => store.donateForm.amount = parseFloat(event.target.value)}
                readOnly={readOnly}
                ref={el => this.amountInput = el}
                required='required'
                step='0.01'
                type='number'
                value={amount}
              />
              <span className='postinput'>{isSubscription ? t('views.donate_form.currency_per_month') : t('views.donate_form.currency')}</span>
            </div>
            <div className='error' />
          </div>
        </div>
      </div>
    );
  }
}

export default DonateFormAmountInput;
